"use strict";

exports.__esModule = true;
exports.DsContextualHelp = void 0;
require("./DsContextualHelp.css");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DsContextualHelp = exports.DsContextualHelp = function DsContextualHelp(_ref) {
  var id = _ref.id,
    openContextualHelp = _ref.openContextualHelp;
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      openContextualHelp(id);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: ["\xA0", /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
      className: 'contextual-help icon icon-sm text-secondary',
      onClick: function onClick() {
        return openContextualHelp(id);
      },
      tabIndex: 0,
      onKeyDown: handleKeyDown,
      children: "help_outline"
    })]
  });
};